let _f
let _c
let _l
let _d

const formatter = ({ currency = 'EUR', locale = 'sk-SK', minimumFractionDigits = 2 }) => {
	if (currency !== _c || locale !== _l || minimumFractionDigits !== _d) {
		const options = currency ? {
			style: 'currency',
			currency: currency,
			minimumFractionDigits
		} : {minimumFractionDigits}
		_f = new Intl.NumberFormat(locale, options)
	}
	_c = currency
	_l = locale
	_d = minimumFractionDigits
	return _f
}

const formatToParts = (value) => {
	const parts = value.split('')

	let currency = ''
	let number = ''
	if (isNaN(parts[0])) {
		for (let i = 0; i < parts.length; i ++) {
			const char = parts[i].trim()
			if (!char.trim().length || !isNaN(char)) {
				number = value.slice(i)
				break
			}
			currency = `${ currency }${ char }`
		}
		return [
			{
				type: 'currency',
				value: currency
			},
			{
				type: 'number',
				value: number
			}
		]
	} else {
		for (let i = parts.length - 1; i >= 0; i --) {
			const char = parts[i].trim()
			if (char.length && !isNaN(char)) {
				number = value.slice(0, i + 1)
				break
			}
			currency = `${ char }${ currency }`
		}
		return [
			{
				type: 'number',
				value: number
			},
			{
				type: 'currency',
				value: currency
			}
		]
	}
}

export function format(value, compact = 'normal', currency, fractionDigits, locale = 'sk-SK') {
	let number = Math.abs(Number(value)) || 0
	let suffix = ''
	let minimumFractionDigits = 2

	if (compact && compact ===  'fullValue'){
		const formatterSettings = formatter({ minimumFractionDigits : 0, currency, locale })
		const convertToNumber = Number(value);
		return isNaN(convertToNumber) ? 'N/A' : formatterSettings.format(convertToNumber)
	}

	minimumFractionDigits = currency === null? fractionDigits || 0 : minimumFractionDigits
	const compactBreakpoints = compact === 'short' ? [1e3, 1e6] : [1e6, 1e9] 
	if (compact && number >= compactBreakpoints[1]) {
		number = Math.round((number / 1e6) * 100) / 100
		suffix = 'M'
		minimumFractionDigits = 1
	} else if (compact && number >= compactBreakpoints[0]) {
		number = Math.round((number / 1e3) * 100) / 100
		suffix = 'K'
		minimumFractionDigits = 0
	}
	const currentFormatter = formatter({ minimumFractionDigits, currency, locale })
	const parts = currentFormatter.formatToParts ? currentFormatter.formatToParts(number) : formatToParts(currentFormatter.format(number))
	let suffixed = false
	let n = parts.reduce((n, p) => {
		suffixed = n.length && p.type === 'currency'
		return suffixed ? `${ n.trim() }${ suffix } ${ p.value }` : `${ n }${ p.value }`
	}, '')
	if (value < 0) {
		n = `-${ n }`
	}
	return !suffixed && suffix.length ? `${ n }${ suffix }` : n
}

export function checkNumberValues(value) {
	if (value && value !== "N/A" ) {
		return format(value);
	}
	return "N/A";
}

export function getPrefixByFileType(fileType){
	if(fileType === "SaftFile")
        return "saft_pt"

    if(fileType === "SaftLtFile")
        return "saft_lt"

    if(fileType === "CsvFile" || /LtErp.*/.test(fileType))
        return "lt_erp"
	
	if(fileType === "SaftAoFile")
		return "saft_ao"

	return "";
}

export function convertBytesToMegaBytes(value, precison = 2){
	if( value ){
		return ((value/ Math.pow(1024,2)).toFixed(precison)).toString()
	}
	return "N/A"
}